export default __webpack_public_path__ + "static/media/img--bathroom-light.96b677e4.jpg";